// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t-fLu","label":"styles_label__2mLPv"};